module.exports = __webpack_public_path__ + "assets/img/login-2.0fcb61b4.jpg";